module.exports = __webpack_public_path__ + "static/media/arrowleft.674a6acd.svg";